<template>
  <header>
    <div>
      <Brand />
    </div>
  </header>
</template>

<script>
  import Brand from '@/components/ui/Brand';

  export default {
    name: 'Header',
    components: {
      Brand,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
    },
  };
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  header {
    position: relative;
    background: $color-black;
    height: 125px;
    width: 100%;

    @include screen-tablet {
      height: 100px;
    }

    & > div {
      position: relative;
      @include max-width-constraints;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        position: absolute;
        top: 108px;
        left: 50%;
        transform-origin: 50% 0;
        transform: translate(-50%, 0);
        width: 100%;
        max-width: 703px;

        svg {
          width: 100%;
          height: auto;
          overflow: visible;
        }

        img {
          position: absolute;
          top: calc(50% - 25px);
          left: calc(50% + 20px);
          width: 85.98%;
          height: auto;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
</style>
